export const removeTrailingZeros = (value: string) => value.replace(/\D00(?=\D*$)/, '');
